import {DateTime,  Settings, Zone } from 'luxon'

export default {
    install(Vue, options){
        //дата
        Vue.prototype.formatDate= function(date){
            var dt= new Date(date)
            return dt.toLocaleDateString()
        }

        //дата+время
        Vue.prototype.formatDateTime= function(date){
            var dt= new Date(date)
            return dt.toLocaleString()
        }

        //время + дата с названием месяца
        Vue.prototype.formatTimeDateMounthName= function(date){
                var dt= new Date(date)
                return DateTime.fromJSDate(dt).toFormat("HH:mm, DD", { locale: "ru" })
        }

        //дата с названием месяца
        Vue.prototype.formatDateMounthName= function(date){
            var dt= new Date(date)
            return DateTime.fromJSDate(dt).toFormat("DD", { locale: "ru" })
        }

        //время
        Vue.prototype.formatTime= function(date){
            var dt= new Date(date)
            return DateTime.fromJSDate(dt).toFormat("HH:mm", { locale: "ru" })

        }
    }
}